// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_TogglegrupousuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /usuarios/toggleGrupoUsuario
 *
 * Returns success flag after toggling user group membership.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_TogglegrupousuarioResponseDados = boolean;

export type Usuarios_TogglegrupousuarioResponse = ApiResponse<Usuarios_TogglegrupousuarioResponseDados>;

registerResponseContract('Usuarios_TogglegrupousuarioResponse', {})
